export const brl = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export const PAY_STATUS = {
  pago: { label: 'Pago', tone: 'success' },
  parcial: { label: 'Parcial', tone: 'warning' },
  nao_pago: { label: 'Não pago', tone: 'danger' },
  isento: { label: 'Isento', tone: 'neutral' },
  nao_participa: { label: 'Não participará', tone: 'neutral' },
};
export const OPEN = ['nao_pago', 'parcial'];
export const AUTH = { autorizado: { label: 'Confirmado', tone: 'success' }, pendente: { label: 'Aguardando resposta', tone: 'warning' }, negado: { label: 'Não participará', tone: 'danger' } };
export const TIPO_LABEL = { passeio: 'Passeio', festa: 'Festa', formatura: 'Formatura', campeonato: 'Campeonato', outro: 'Outro' };
export const STATUS_LABEL = { planejamento: 'Planejamento', inscricoes_abertas: 'Inscrições abertas', confirmado: 'Confirmado', realizado: 'Realizado', cancelado: 'Cancelado' };
export const METHODS = [['pix', 'PIX'], ['cash', 'Dinheiro'], ['card_debit', 'Débito'], ['card_credit', 'Crédito'], ['pix_card', 'PIX no cartão']];
export const fmtDate = (s) => (s ? String(s).slice(0, 10).split('-').reverse().join('/') : '—');
